   
// When the user scrolls the page, execute stickyFilter 
      window.onscroll = function() {stickyFilter()};

      // Get the header
      var header = document.getElementById("filter-wrapper");
      var filterPad = document.getElementsByClassName("collection-products")[0];

      // Get the offset position of the navbar
      var sticky = header.offsetTop;

      // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
      function stickyFilter() {
        if (window.pageYOffset > sticky) {
          header.classList.add("sticky-filter");
          if (filterPad.style.paddingTop == "0px"|| filterPad.style.paddingTop == "") {
            filterPad.style.paddingTop = header.offsetHeight + 'px';//
          }
        } else {
          header.classList.remove("sticky-filter");
          if (filterPad.style.paddingTop != "0px") {
            filterPad.style.paddingTop = "0px";
          }
        }
      }
      
      // Change the text of the button
      /*var filterButton = document.getElementById("filter");
      filterButton.onclick = function() { updateValues() };
      function updateValues() {
        if (filterButton["attributes"]["aria-expanded"].value == "true"
           && filterButton.innerHTML = "Filter Styles +") {
          filterButton.innerHTML = "Collapse Filter";
        } else {
          filterButton.innerHTML = "Filter Styles +";
        }
      }*/
